<!--
 * @Author: zql
 * @Date: 2020-03-13 15:29:14
 * @LastEditTime: 2020-06-02 14:32:47
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \enfry-components\packages\components\en-result\src\nodataAdd\nodata-add.vue
-->
<template>
  <div ref="NodataAdd" class="nodata-add">
    <img
      slot="icon"
      class="icon-img"
      src="http://cdn.enfry.com/nodata-add11337.png"
      :alt="this.title"
    />
    <div class="title" v-html="title"></div>
    <div class="subtitle" v-html="subTitle"></div>
  </div>
</template>

<script>
export default {
  name: "NodataAdd",
  props: {
    type: { type: String, default: null },
    icon: {
      type: String,
      default: null
    },
    iconSize: {
      type: [String, Number],
      default: "normal"
    },
    title: {
      type: String,
      default: null
    },
    subTitle: {
      type: String,
      default: "很抱歉，暂无数据哦~ 请点击上方的添加按钮"
    }
  }
};
</script>
<style lang="scss" scoped>
.nodata-add {
  text-align: center;
  .icon-img {
    height: 118px;
    width: 82px;
  }
  .subtitle {
    margin: 0 auto;
    text-align: center;
    width: 144px;
    margin: 0 auto;
  }
}
</style>
